<template>
  <div class="modal" :class="{'is-active': opened}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Submit to NS</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div>
          <div v-if="error" class="notification is-danger is-light">
            <button class="delete" @click="error=''"></button>
            {{error}}
          </div>
          <div v-if="waiting">
            Checking...
            <span class="icon is-medium is-size-4">
              <i class="fas fa-spinner fa-pulse"></i>
            </span>
          </div>
          <div v-else>
            <article class="message is-danger" v-if="errors && errors.length">
              <div class="message-header">
                <p>Because of the following errors, it cannot create bill in NetSuite. Though, you can click the button below to change its status without saving in NetSuite.</p>
              </div>
              <div class="message-body">
                <ol>
                  <li v-for="(e, i) in errors" :key="'e-'+i">
                    {{ e }}
                  </li>
                </ol>
              </div>
            </article>
            <article class="message is-info" v-if="errors && !errors.length">
              <div class="message-header">
                <p>All checks passed.</p>
              </div>
              <div class="message-body">
                You can click the button below to submit NS bill in NetSuite.
              </div>
            </article>
          </div>
        </div>

      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" :class="{'is-loading': waiting || sending}" @click="submitCost">{{canSubmit ? 'Submit NS bill' : 'Change status'}}</a>
        <a class="button" @click="close">Cancel</a>
      </footer>
    </div>
  </div>
</template>
  
<script>

export default {
  name: 'submit-cost-modal',
  props: ['opened', 'costMessage'],
  data () {
    return {
      errors: [],
      waiting: false,
      canSubmit: false,
      sending: false,
      error: '',
      vendorId: '',
      subsidiaryId: '',
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
  },
  watch: {
    opened: function (val) {
      if (val) {
        this.errors = []
        this.canSubmit = false
        this.sending = false
        this.error = ''
        this.vendorId = ''
        this.subsidiaryId = ''
        this.checkCostForSubmit()
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeSubmitCostModal', false)
    },
    submitCost () {
      if (this.waiting) {
        return
      }
      if (this.canSubmit) {
        this.sending = true
        var message = {
          ...this.costMessage,
          vendorId: this.vendorId,
          subsidiaryId: this.subsidiaryId,
        }
        this.$http.post(this.server + '/myapp/submit-cost-and-create-bill/', message).then(resp => {
          this.sending = false
          this.$emit('closeSubmitCostModal', true)
        }, err => {
          this.error = err.body
          this.sending = false
        })
      } else {
        this.sending = true
        this.$http.post(this.server + '/myapp/update-cost/' + this.costMessage.id + '/', this.costMessage).then(resp => {
          this.sending = false
          this.$emit('closeSubmitCostModal', true)
        }, err => {
          this.error = err.body
          this.sending = false
        })
      }
    },
    checkCostForSubmit () {
      this.waiting = true
      this.$http.post(this.server + '/myapp/check-cost-for-submit/', this.costMessage).then(resp => {
        this.errors = resp.body.errors || []
        if (!this.errors.length) {
          this.canSubmit = true
          this.vendorId = resp.body.vendorId
          this.subsidiaryId = resp.body.subsidiaryId
        }
        this.waiting = false
      }, err => {
        this.errors = [err.body]
        this.waiting = false
      })
    }
  },
}
</script>

<style scoped>

</style>